import {
    getExportDetailsData,
    ExportDataParameter,
    ExportDetailsDataApiModel,
} from "@gemeco/Services/GemecoInventoryDataService";
import {
    ApiHandler,
    createHandlerChainRunner,
} from "@insite/client-framework/HandlerCreator";

type HandlerType = ApiHandler<ExportDataParameter, ExportDetailsDataApiModel>;

export const DispatchBeginExportDetailsData: HandlerType = (props: any) => {
    props.dispatch({
        type: "Custom/ExportDetailsData/BeginLoadExportDetailsData",
    });
};

export const RequestDataFromExportDetailsApi: HandlerType = async (props: any) => {
    props.apiResult = await getExportDetailsData(props.parameter);
};

export const DispatchCompleteExportDetailsData: HandlerType = (props: any) => {
    if (!props.apiResult) {
        return;
    }
    props.dispatch({
        type: "Custom/ExportDetailsData/CompletedLoadExportDetailsData",
        result: props.apiResult,
    });
};

export const chain = [DispatchBeginExportDetailsData, RequestDataFromExportDetailsApi, DispatchCompleteExportDetailsData];

const gemecoExportDetailsHandler = createHandlerChainRunner(chain, "GemecoExportDetailsHandler");
export default gemecoExportDetailsHandler;